// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsTabsItems__container{width:100%}.NsTabsItems__item{display:none}.NsTabsItems__item.NsTabsItems__selected{display:block}", ""]);
// Exports
exports.locals = {
	"container": "NsTabsItems__container",
	"item": "NsTabsItems__item",
	"selected": "NsTabsItems__selected"
};
module.exports = exports;
